import { styled, Typography } from '@mui/material';

export const Header = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '5px',
}));

export const Content = styled('div')(() => ({
  width: '100%',
}));

export const SearchControls = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& > :first-of-type': {
    flex: 1,
    minWidth: 0,
  },
}));

export const Row = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  cursor: 'pointer',
  padding: '4px',
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
}));

export const Tags = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
}));
